export default [
    {
      name: 'Dashboard',
      icon: 'nc-icon nc-bank',
      path: '/admin/overview',
      permission:''
    },
    {
      name: 'Usuarios',
      icon: 'nc-icon nc-single-02',
      path: '/users',
      permission:'view_user'
    },
    {
      name: 'Parametrizaciones',
      icon: 'nc-icon nc-settings-gear-65',
      children: [
        {
          name: 'Regionales',
          path: '/parametrizations/regionals',
          permission:'view_regional'
        },
        {
          name: 'Oficinas',
          path: '/parametrizations/offices',
          permission:'view_office'
        },
        {
          name: 'Tipos de analistas',
          path: '/parametrizations/analyst_types',
          permission:'view_analysttype'
        },
        {
          name: 'Etapas',
          path: '/parametrizations/credit_request_stages',
          permission:'view_creditrequeststage'
        },
        {
          name: 'Tipos de producto',
          path: '/parametrizations/product_types',
          permission:'view_producttype'
        },
        {
          name: 'Tipos de crédito',
          path: '/parametrizations/credit_types',
          permission:'view_credittype'
        },
        {
          name: 'Tipos de documento',
          path: '/parametrizations/identification_document_types',
          permission:'view_identificationdocumenttype'
        },
        {
          name: 'Tipos de actividad',
          path: '/parametrizations/activity_types',
          permission:'view_activitytype'
        },
        {
          name: 'Tipos de cliente',
          path: '/parametrizations/client_types',
          permission:'view_activitytype'
        },
        {
          name: 'Tipos de cuenta',
          path: '/parametrizations/account_types',
          permission:'view_activitytype'
        },
        {
          name: 'Tipos de O.F',
          path: '/parametrizations/financial_obligation_types',
          permission:'view_activitytype'
        },
        // {
        //   name: 'Montos y plazos - CT',
        //   path: '/parametrizations/amount_terms_wc',
        //   permission:'view_activitytype'
        // },
        // {
        //   name: 'Montos y plazos - AF',
        //   path: '/parametrizations/amount_terms_fa',
        //   permission:'view_activitytype'
        // },
        // {
        //   name: 'Cuota contingente - Agro',
        //   path: '/parametrizations/contingent_quota_tdc_agro',
        //   permission:'view_activitytype'
        // },
        {
          name: 'Cuota contingente - Pyme',
          path: '/parametrizations/contingent_quota_tdc_pyme',
          permission:'view_activitytype'
        },
        // {
        //   name: 'Tasas de crédito',
        //   path: '/parametrizations/credit_rate',
        //   permission:'view_activitytype'
        // },
        // {
        //   name: 'Comisiones',
        //   path: '/parametrizations/commission',
        //   permission:'view_activitytype'
        // },
        {
          name: 'Destinos del crédito',
          path: '/parametrizations/credit_purposes',
          permission:'view_creditpurpose'
        },
        {
          name: 'Porcentaje de catálogos',
          path: '/parametrizations/catalog_percent',
          permission:'view_creditpurpose'
        },
        {
          name: 'Variables del sistema',
          path: '/parametrizations/settings',
          permission:'view_systemsettings'
        },
        {
          name: 'Roles y permisos',
          path: '/parametrizations/permissions',
          permission:'view_group'
        }

      ]
    },
    {
      name: 'Logs',
      icon: 'nc-icon nc-zoom-split',
      children: [
        {
          name: 'Usuarios conectados',
          path: '/logs/online_users',
          permission:'view_session'
        },
        {
          name: 'Ingresos al sistema',
          path: '/logs/system_logging',
          permission:'view_accessattempt'
        },
      ]
    },
    {
      name: 'Evaluaciones',
      icon: 'nc-icon nc-single-copy-04',
      path: '/assessments/assessments',
      permission:'view_financialassessment'
    },
  ]
